// extracted by mini-css-extract-plugin
var _1 = "CalendarView-moduleCalendarView__iGIi3";
export { _1 as "CalendarView" }
